import type { SmartComboboxOption } from "../shared/smart-combobox";

const options = (items: string[]): SmartComboboxOption[] =>
  items.map((label) => ({ label, value: label }));

export const DEGREE_OPTIONS = options([
  // Enseignement secondaire
  "CEP",
  "BEPC",
  "Brevet des collèges",
  "Probatoire",
  "Baccalauréat",
  "Baccalauréat général",
  "Baccalauréat technique",
  "Baccalauréat professionnel",
  "First School Leaving Certificate",
  "GCE Ordinary Level",
  "GCE Advanced Level",
  "WASSCE",
  "High School Diploma",
  // Formation professionnelle et technique
  "CAP",
  "BEP",
  "CQP",
  "Brevet de technicien (BT)",
  "Brevet professionnel",
  "Titre professionnel",
  "Certificat de spécialisation",
  // Bac + 2 et bac + 3
  "BTS",
  "DUT",
  "BUT",
  "HND",
  "DEUG",
  "DEUST",
  "Diplôme d’études universitaires",
  "Associate Degree",
  "Licence",
  "Licence professionnelle",
  "Bachelor",
  "Bachelor of Arts",
  "Bachelor of Science",
  "Bachelor of Engineering",
  "Diplôme d’infirmier d’État",
  "Diplôme d’État",
  // Bac + 4 et bac + 5
  "Maîtrise",
  "Master 1",
  "Master 2",
  "Master",
  "Master professionnel",
  "Master recherche",
  "Master of Science",
  "Master of Arts",
  "MBA",
  "Executive MBA",
  "DEA",
  "DESS",
  "Diplôme d’ingénieur",
  "Diplôme d’ingénieur des travaux",
  "Diplôme d’école de commerce",
  "Mastère spécialisé",
  "Diplôme d’expertise comptable",
  "Certificat d’aptitude à la profession d’avocat",
  // Bac + 6 et plus
  "Doctorat",
  "PhD",
  "Doctorat en médecine",
  "Doctorat en pharmacie",
  "Doctorat en chirurgie dentaire",
  "Diplôme de spécialisation médicale",
  "Habilitation à diriger des recherches",
  // Certificats et autres
  "Diplôme universitaire",
  "Certificat",
  "Certification professionnelle",
  "Attestation de formation",
  "Formation en ligne",
]);

export const STUDY_AREA_OPTIONS = options([
  "Administration",
  "Agriculture",
  "Architecture",
  "Banque et finance",
  "Commerce",
  "Communication",
  "Comptabilité",
  "Droit",
  "Économie",
  "Éducation",
  "Gestion de projet",
  "Informatique",
  "Ingénierie",
  "Logistique",
  "Marketing",
  "Médecine",
  "Ressources humaines",
  "Réseaux et télécommunications",
  "Santé",
]);
